import { render, staticRenderFns } from "./ctaItem.vue?vue&type=template&id=8ec2a37a&scoped=true"
import script from "./ctaItem.vue?vue&type=script&lang=js"
export * from "./ctaItem.vue?vue&type=script&lang=js"
import style0 from "./ctaItem.vue?vue&type=style&index=0&id=8ec2a37a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec2a37a",
  null
  
)

export default component.exports